<div class="actions-cell">
    <button class=" btn btn-link delete-button" (click)="onDeleteClick()">Delete</button>
    <button class=" btn btn-link edit-button" (click)="onEditClick()">Edit</button>
</div>